//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PageLimiter from '../PageLimiter.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import BtnBack from '../BtnBack.vue';
import Btn from '../Btn.vue';
import ProductTile from '../ProductTile.vue';
import FeedbackTile from '../FeedbackTile.vue';
import PageContent from '../PageContent.vue';

export default {
	name: 'PageCatalogInner',

	components: { PageLimiter: PageLimiter, Breadcrumbs: Breadcrumbs, BtnBack: BtnBack, Btn: Btn, ProductTile: ProductTile, FeedbackTile: FeedbackTile, PageContent: PageContent },

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		content: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}

	},

	data: function data() {
		return {

			activeTabIndex: 0,

			itemCardCarouselOptions: {
				slidesPerView: 1,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				}
			},

			recItemsCarouselOptions: {
				slidesPerView: 'auto',
				//slidesPerView: 4,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},

				breakpoints: {
					400: {
						slidesPerView: 1
					}
				}
			}
		};
	},


	computed: {
		baseUrl: function baseUrl() {
			var url = void 0;
			switch (this.$route.params.lang) {
				case 'en':
					url = 'eng/';
					break;
				default:
					url = '';
					break;
			}
			return url + this.$route.params.page;
		},
		item: function item() {
			return this.content.item;
		},
		recItems: function recItems() {
			return this.content.recItems;
		},
		prevNext: function prevNext() {
			var _this = this;

			var slugs = this.page.currentSlugs || [],
			    links = [];

			slugs.forEach(function (slug, index) {
				if (slug === _this.$route.params.inner) {
					links = [slugs[index - 1], slugs[index + 1]];
				}
			});

			return links;
		}
	},

	methods: {
		setTab: function setTab(index) {
			this.activeTabIndex = index;
			this.itemCardCarousel.slideTo(index, 400, false);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCatalogInner.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCatalogInner.vue
// module chunks = 1 2